module.exports = __webpack_public_path__ + "static/media/varify-badge-step2.52daaa4e.png";